import Vue from 'vue';

export const mutationTypes = {
  getEmailsStart: '[email] get emails start',
  getEmailsSuccess: '[email] get emails success',
  getEmailsFailure: '[email] get emails failure',

  getVariablesStart: '[email] get variables start',
  getVariablesSuccess: '[email] get variables success',
  getVariablesFailure: '[email] get variables failure',

  getTemplateStart: '[email] get template start',
  getTemplateSuccess: '[email] get template success',
  getTemplateFailure: '[email] get template failure',

  getSettingsStart: '[email] get settings start',
  getSettingsSuccess: '[email] get settings success',
  getSettingsFailure: '[email] get settings failure',

  setSettings: '[email] set settings',
  resetSettings: '[email] reset settings',

  changeSettingsStart: '[email] change settings start',
  changeSettingsSuccess: '[email] change settings success',
  changeSettingsFailure: '[email] change settings failure',

  setActiveStep: '[email] set active step',

  resetEmailStart: '[email] reset email start',
  resetEmailSuccess: '[email] reset email success',
  resetEmailFailure: '[email] reset email failure',
};

const mutations = {
  [mutationTypes.getEmailsStart](state) {
    state.emails = null;
    state.isLoading = true;
  },
  [mutationTypes.getEmailsSuccess](state, payload) {
    state.isLoading = false;
    state.emails = payload;
  },
  [mutationTypes.getEmailsFailure](state) {
    state.isLoading = false;
  },

  [mutationTypes.getVariablesStart](state) {
    state.variables = null;
    state.isLoading = true;
  },
  [mutationTypes.getVariablesSuccess](state, payload) {
    state.isLoading = false;
    state.variables = payload;
  },
  [mutationTypes.getVariablesFailure](state) {
    state.isLoading = false;
  },

  [mutationTypes.getTemplateStart](state) {
    state.isLoading = true;
  },
  [mutationTypes.getTemplateSuccess](state, payload) {
    state.isLoading = false;
    state.template = payload;
  },
  [mutationTypes.getTemplateFailure](state) {
    state.isLoading = false;
  },

  [mutationTypes.getSettingsStart](state) {
    state.isLoading = true;
  },
  [mutationTypes.getSettingsSuccess](state, {settings}) {
    state.isLoading = false;

    if (settings) {
      state.settings.subject = settings.subject;
      state.settings.greeting = settings.greeting;
      state.settings.text = settings.text;
    }
  },
  [mutationTypes.getSettingsFailure](state) {
    state.isLoading = false;
  },

  [mutationTypes.setSettings](state, {key, value}) {
    const settings = {...state.settings};
    settings[key] = value;
    Vue.set(state, 'settings', settings);
  },
  [mutationTypes.resetSettings](state) {
    const settings = {
      subject: '',
      greeting: '',
      text: '',
    };
    Vue.set(state, 'settings', settings);
  },

  [mutationTypes.changeSettingsStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.changeSettingsSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.changeSettingsFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.setActiveStep](state, step) {
    state.activeStep = step;
  },

  [mutationTypes.resetEmailStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.resetEmailSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.resetEmailFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },
};

export default mutations;
